import { Link as RouterLink } from "react-router-dom";
import generateCloudinaryLink from 'src/_utils/generateCloudinaryLink';
import { Business } from '@mui/icons-material';
import { useTranslation } from "react-i18next";
import { Avatar, Badge, Box, Chip, Typography } from "@mui/material";
import { ROLES } from "src/constants";
import { useSelector } from "react-redux";
export default function DrawerAccountWelcome({ companyName, logo, ...props }) {
    const { t } = useTranslation()
    const profile = useSelector((state) => state.entities.profile.profile);
    const customizations = useSelector(state => state.entities.customizations)

    return (
        <Box
            alignItems="center"
            display="flex"
            flexDirection="column"
            py={2}
            bgcolor="main.dark"
            {...props}
        >
            {!!customizations?.warehouse &&
                <Box display="flex" flexDirection="column" sx={{ mb: 1 }}>
                    <Typography color="secondary" variant="caption">
                        {t("The customized warehouse")}
                    </Typography>
                    <Chip size="small" color='secondary' label={customizations?.warehouse?.name} />
                </Box>
            }
            <Typography color="text.white" variant="subtitle1">
                {t("Welcome")}
            </Typography>
            <Typography color="text.white" variant="h2" mb={1} sx={{ textAlign: 'center', width: 238 }}>
                {companyName}
            </Typography>
            {/* {(!!profile && !!profile.planAvailableDays && profile.role === ROLES.shippingCompany) &&
                <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" px={3}>
                    <Typography color="secondary" variant="h6" mb={1}>
                        {t("Remaining days")}
                    </Typography>
                    <Badge badgeContent={profile.planAvailableDays} color="secondary" sx={{mb: 1}} />
                </Box>
            } */}
            {/* <Avatar
                component={RouterLink}
                src={generateCloudinaryLink(logo)}
                sx={{
                    cursor: "pointer",
                    width: "100px",
                    height: "100px",
                    m: "7px",
                    mb: "-50px",
                    borderWidth: 7,
                    borderStyle: "solid",
                    borderColor: "main.dark"
                }}
                to="/merchant/account"
            >
                <Business sx={{ width: "60px", height: "60px" }} />
            </Avatar> */}
        </Box>
    )
}